import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  SmallFlatButton,
} from '../../../tc-ui/small-buttons';
import {
  removeMasterTemplate as removeMasterTemplateAction,
} from '../../__storeFiles__/actions';
import { Link } from 'react-router';
import { push as pushAction } from 'react-router-redux';
import injectCss from 'react-jss';

const PickMasterBtnIndicator = props => {
  const {
    push,
    removeMasterTemplate,
    templateDraftId,
    masterTemplateName,
    masterTemplateType,
    masterTemplateId,
    editable,
  } = props;
  if (masterTemplateId) {
    return (
      <div className="flex-center">
        <Link
          to={`/contracting/master-template/${masterTemplateId}`}
          style={{ fontSize: '14px' }}
        >
          Corporate Policies & Notes applied: {masterTemplateName}
        </Link>
        {
          editable && (
            <SmallFlatButton
              style={{ border: '1px solid #ff4081', marginLeft: '8px' }}
              primary
              labelStyle={{ padding: '0 6px' }}
              label="Remove Corporate Template"
              onTouchTap={removeMasterTemplate}
            />
          )
        }
      </div>
    );
  }
  if (!editable) {
    return <div/>;
  }
  return (
    <SmallFlatButton
      style={{ border: '1px solid #00bcd4' }}
      secondary
      labelStyle={{ padding: '0 6px', top: '-1px' }}
      label="Apply A Corporate Template"
      onTouchTap={() => push(`/contracting/pick-master-template/${
        templateDraftId
      }?type=${masterTemplateType}`)}
    />
  );
};

PickMasterBtnIndicator.propTypes = {
  push: PropTypes.func,
  removeMasterTemplate: PropTypes.func,
  templateDraftId: PropTypes.string,
  masterTemplateName: PropTypes.string,
  masterTemplateType: PropTypes.string,
  masterTemplateId: PropTypes.string,
  editable: PropTypes.bool,
};

export default connect(null, {
  push: pushAction,
  removeMasterTemplate: removeMasterTemplateAction,
})(injectCss({

})(PickMasterBtnIndicator));



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/btns-switches/pick-master-button-n-indicator.jsx